import { useContext } from "react";

import { IStudyContextData } from "@syntensor/common/types";
import getCopy from "@syntensor/common/data/copy";
import Select from "@syntensor/common/components/select";

import { StudyDataContext } from "..";
import StudyComponentsGrid from "../components/components_grid";
import StudiesTitle from "../title";

import styles from "../studies.module.css";

export default function StudyMoa() {
  const studyData = useContext<IStudyContextData | null>(StudyDataContext);
  const { cellLines = [] } = studyData || {};

  return (
    <>
      <div className={styles.titles}>
        <StudiesTitle />
      </div>
      <div className={styles.sectionHeader}>
        <div className={styles.controls}>
          <div className={styles.controlRow}>
            <div className={styles.mainControl}>
              <h3 className={styles.subtitle}>
                {getCopy("studies_moa_title")}
              </h3>
            </div>
            <div className={styles.noGrowControl}>
              <Select
                label={getCopy("studies_components_cellline-dropdown")}
                size="small"
                options={cellLines}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.sectionContent}>
        <StudyComponentsGrid hasFilters={false} componentType="moa" />
      </div>
    </>
  );
}
